import {CategoryNameField} from './category-name-field';

export default CategoryNameField;